@file:OptIn(InternalResourceApi::class)

package gloopgo.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.ScriptQualifier
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gloopgo.shared.generated.resources/"

@delegate:ResourceContentHash(-1_450_149_642)
internal val Res.string.ai_player_body: StringResource by lazy {
      StringResource("string:ai_player_body", "ai_player_body", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 10, 50),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 10, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 50),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10, 70),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 10, 58),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 10, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 50),
      ))
    }

@delegate:ResourceContentHash(983_224_280)
internal val Res.string.ai_player_ok: StringResource by lazy {
      StringResource("string:ai_player_ok", "ai_player_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 61, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 61, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61, 24),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 81, 24),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 69, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 61, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61, 24),
      ))
    }

@delegate:ResourceContentHash(256_201_984)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 90, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 90, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 90, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 86, 28),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 106, 28),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 98, 28),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 90, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86, 28),
      ))
    }

@delegate:ResourceContentHash(1_502_793_271)
internal val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 119, 20),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 119, 20),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119, 20),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115, 20),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 135, 20),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 127, 20),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 119, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151, 20),
      ))
    }

@delegate:ResourceContentHash(-1_423_294_320)
internal val Res.string.back_to_hub: StringResource by lazy {
      StringResource("string:back_to_hub", "back_to_hub", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115, 35),
      ))
    }

@delegate:ResourceContentHash(-1_520_698_253)
internal val Res.string.blocked_player_name: StringResource by lazy {
      StringResource("string:blocked_player_name", "blocked_player_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 140, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 140, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 140, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 136, 47),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 156, 71),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 148, 59),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 140, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172, 47),
      ))
    }

@delegate:ResourceContentHash(-1_765_165_358)
internal val Res.string.blocked_players_empty: StringResource by lazy {
      StringResource("string:blocked_players_empty", "blocked_players_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 192, 69),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 192, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 192, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184, 69),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 228, 105),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 208, 81),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 192, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 220, 69),
      ))
    }

@delegate:ResourceContentHash(-75_443_565)
internal val Res.string.blocked_players_title: StringResource by lazy {
      StringResource("string:blocked_players_title", "blocked_players_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 262, 53),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 262, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 258, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 254, 53),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 334, 73),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 290, 61),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 262, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290, 49),
      ))
    }

@delegate:ResourceContentHash(-551_830_352)
internal val Res.string.blocked_players_unblock: StringResource by lazy {
      StringResource("string:blocked_players_unblock", "blocked_players_unblock", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 316, 47),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 316, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 316, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 308, 47),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 408, 39),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 352, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 316, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 340, 43),
      ))
    }

@delegate:ResourceContentHash(1_163_680_766)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 384, 22),
      ))
    }

@delegate:ResourceContentHash(-549_337_528)
internal val Res.string.clear_data_button: StringResource by lazy {
      StringResource("string:clear_data_button", "clear_data_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 407, 53),
      ))
    }

@delegate:ResourceContentHash(99_473_562)
internal val Res.string.clear_data_card_title: StringResource by lazy {
      StringResource("string:clear_data_card_title", "clear_data_card_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 461, 49),
      ))
    }

@delegate:ResourceContentHash(2_039_531_755)
internal val Res.string.clear_data_confirm: StringResource by lazy {
      StringResource("string:clear_data_confirm", "clear_data_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 511, 42),
      ))
    }

@delegate:ResourceContentHash(2_100_952_684)
internal val Res.string.clear_data_desc: StringResource by lazy {
      StringResource("string:clear_data_desc", "clear_data_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 554, 203),
      ))
    }

@delegate:ResourceContentHash(-1_534_828_570)
internal val Res.string.clear_data_dialog_desc: StringResource by lazy {
      StringResource("string:clear_data_dialog_desc", "clear_data_dialog_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 758, 178),
      ))
    }

@delegate:ResourceContentHash(102_412_839)
internal val Res.string.clear_data_dialog_title: StringResource by lazy {
      StringResource("string:clear_data_dialog_title", "clear_data_dialog_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 937, 51),
      ))
    }

@delegate:ResourceContentHash(-1_936_790_530)
internal val Res.string.clear_data_success: StringResource by lazy {
      StringResource("string:clear_data_success", "clear_data_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 989, 54),
      ))
    }

@delegate:ResourceContentHash(1_285_925_246)
internal val Res.string.connecting_back_to_menu: StringResource by lazy {
      StringResource("string:connecting_back_to_menu", "connecting_back_to_menu", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 364, 47),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 364, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 364, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 356, 51),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 448, 59),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 404, 63),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 364, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1044, 47),
      ))
    }

@delegate:ResourceContentHash(1_595_221_377)
internal val Res.string.connecting_error_default: StringResource by lazy {
      StringResource("string:connecting_error_default", "connecting_error_default", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 412, 124),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 412, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 416, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 408, 144),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 508, 168),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 468, 152),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 412, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1092, 120),
      ))
    }

@delegate:ResourceContentHash(533_357_701)
internal val Res.string.connecting_error_title: StringResource by lazy {
      StringResource("string:connecting_error_title", "connecting_error_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 537, 46),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 537, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 545, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 553, 58),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 677, 50),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 621, 50),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 537, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1213, 54),
      ))
    }

@delegate:ResourceContentHash(-1_658_586_798)
internal val Res.string.connecting_retry: StringResource by lazy {
      StringResource("string:connecting_retry", "connecting_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 584, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 584, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 600, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 612, 40),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 728, 36),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 672, 36),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 584, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1268, 32),
      ))
    }

@delegate:ResourceContentHash(-1_669_025_443)
internal val Res.string.connecting_status_default: StringResource by lazy {
      StringResource("string:connecting_status_default", "connecting_status_default", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 617, 77),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 617, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 641, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 653, 77),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 765, 89),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 709, 81),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 617, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1301, 73),
      ))
    }

@delegate:ResourceContentHash(-924_443_649)
internal val Res.string.connecting_status_joined: StringResource by lazy {
      StringResource("string:connecting_status_joined", "connecting_status_joined", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 695, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 695, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 719, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 731, 48),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 855, 60),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 791, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 695, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1375, 44),
      ))
    }

@delegate:ResourceContentHash(-211_390_075)
internal val Res.string.connecting_status_joining: StringResource by lazy {
      StringResource("string:connecting_status_joining", "connecting_status_joining", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 744, 97),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 744, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 768, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 780, 93),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 916, 109),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 844, 97),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 744, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1420, 77),
      ))
    }

@delegate:ResourceContentHash(1_640_970_175)
internal val Res.string.connecting_title: StringResource by lazy {
      StringResource("string:connecting_title", "connecting_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 842, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 842, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 858, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 874, 40),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1026, 40),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 942, 44),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 842, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1498, 44),
      ))
    }

@delegate:ResourceContentHash(-411_709_301)
internal val Res.string.game_btn_eject: StringResource by lazy {
      StringResource("string:game_btn_eject", "game_btn_eject", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 883, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 883, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 903, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 915, 34),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1067, 30),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 987, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 883, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1543, 30),
      ))
    }

@delegate:ResourceContentHash(-1_984_960_028)
internal val Res.string.game_btn_split: StringResource by lazy {
      StringResource("string:game_btn_split", "game_btn_split", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 914, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 914, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 938, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 950, 34),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1098, 30),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1018, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 914, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1574, 30),
      ))
    }

@delegate:ResourceContentHash(-1_958_146_399)
internal val Res.string.game_exit_confirm_leave: StringResource by lazy {
      StringResource("string:game_exit_confirm_leave", "game_exit_confirm_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 945, 39),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 945, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 973, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 985, 43),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1129, 47),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1049, 43),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 945, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1605, 39),
      ))
    }

@delegate:ResourceContentHash(-1_596_736_328)
internal val Res.string.game_exit_confirm_message: StringResource by lazy {
      StringResource("string:game_exit_confirm_message", "game_exit_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 985, 133),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 985, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1013, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1029, 157),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1177, 177),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1093, 145),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 985, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1645, 157),
      ))
    }

@delegate:ResourceContentHash(-1_897_010_402)
internal val Res.string.game_exit_confirm_stay: StringResource by lazy {
      StringResource("string:game_exit_confirm_stay", "game_exit_confirm_stay", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1119, 50),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1119, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1171, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1187, 38),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1355, 38),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1239, 46),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1119, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1803, 38),
      ))
    }

@delegate:ResourceContentHash(-1_284_004_167)
internal val Res.string.game_exit_confirm_title: StringResource by lazy {
      StringResource("string:game_exit_confirm_title", "game_exit_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1170, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1170, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1214, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1226, 59),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1394, 75),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1286, 75),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1170, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1842, 47),
      ))
    }

@delegate:ResourceContentHash(-772_147_137)
internal val Res.string.game_hud_joystick: StringResource by lazy {
      StringResource("string:game_hud_joystick", "game_hud_joystick", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1222, 33),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1222, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1278, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1286, 37),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1470, 57),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1362, 41),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1222, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1890, 37),
      ))
    }

@delegate:ResourceContentHash(-510_849_910)
internal val Res.string.game_hud_leaderboard: StringResource by lazy {
      StringResource("string:game_hud_leaderboard", "game_hud_leaderboard", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1256, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1256, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1316, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1324, 44),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1528, 48),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1404, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1256, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1928, 44),
      ))
    }

@delegate:ResourceContentHash(-1_558_728_950)
internal val Res.string.game_hud_mass: StringResource by lazy {
      StringResource("string:game_hud_mass", "game_hud_mass", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1297, 37),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1297, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1365, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1369, 37),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1577, 37),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1445, 37),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1297, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1973, 37),
      ))
    }

@delegate:ResourceContentHash(1_213_723_688)
internal val Res.string.game_hud_pause: StringResource by lazy {
      StringResource("string:game_hud_pause", "game_hud_pause", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1335, 30),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1335, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1403, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1407, 30),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1615, 38),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1483, 42),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1335, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2011, 30),
      ))
    }

@delegate:ResourceContentHash(-111_820_499)
internal val Res.string.game_over_main_menu: StringResource by lazy {
      StringResource("string:game_over_main_menu", "game_over_main_menu", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1366, 39),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1366, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1434, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1438, 47),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1654, 55),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1526, 47),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1366, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2042, 39),
      ))
    }

@delegate:ResourceContentHash(151_248_277)
internal val Res.string.game_over_play_again: StringResource by lazy {
      StringResource("string:game_over_play_again", "game_over_play_again", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1406, 44),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1406, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1482, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1486, 40),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1710, 56),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1574, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1406, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2082, 44),
      ))
    }

@delegate:ResourceContentHash(-1_520_989_139)
internal val Res.string.game_over_stats: StringResource by lazy {
      StringResource("string:game_over_stats", "game_over_stats", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1451, 71),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1451, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1531, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1527, 71),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1767, 71),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1627, 75),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1451, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2127, 67),
      ))
    }

@delegate:ResourceContentHash(1_090_890_072)
internal val Res.string.game_over_title: StringResource by lazy {
      StringResource("string:game_over_title", "game_over_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1523, 39),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1523, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1603, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1599, 43),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1839, 51),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1703, 43),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1523, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2195, 35),
      ))
    }

@delegate:ResourceContentHash(-481_781_703)
internal val Res.string.game_paused_exit: StringResource by lazy {
      StringResource("string:game_paused_exit", "game_paused_exit", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1563, 44),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1563, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1651, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1643, 44),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1891, 52),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1747, 44),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1563, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2231, 40),
      ))
    }

@delegate:ResourceContentHash(2_114_290_345)
internal val Res.string.game_paused_hint: StringResource by lazy {
      StringResource("string:game_paused_hint", "game_paused_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1608, 68),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1608, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1696, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1688, 80),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1944, 72),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1792, 76),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1608, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2272, 64),
      ))
    }

@delegate:ResourceContentHash(253_179_015)
internal val Res.string.game_paused_restart: StringResource by lazy {
      StringResource("string:game_paused_restart", "game_paused_restart", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1677, 43),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1677, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1769, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1769, 43),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2017, 43),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1869, 47),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1677, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2337, 39),
      ))
    }

@delegate:ResourceContentHash(-1_014_958_872)
internal val Res.string.game_paused_resume: StringResource by lazy {
      StringResource("string:game_paused_resume", "game_paused_resume", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1721, 42),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1721, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1809, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1813, 38),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2061, 34),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1917, 42),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1721, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2377, 34),
      ))
    }

@delegate:ResourceContentHash(199_903_631)
internal val Res.string.game_paused_title: StringResource by lazy {
      StringResource("string:game_paused_title", "game_paused_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1764, 41),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1764, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1848, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1852, 45),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2096, 53),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 1960, 53),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1764, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2412, 41),
      ))
    }

@delegate:ResourceContentHash(992_576_839)
internal val Res.string.hub_subtitle: StringResource by lazy {
      StringResource("string:hub_subtitle", "hub_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2454, 44),
      ))
    }

@delegate:ResourceContentHash(-567_443_114)
internal val Res.string.hub_version_label: StringResource by lazy {
      StringResource("string:hub_version_label", "hub_version_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2499, 33),
      ))
    }

@delegate:ResourceContentHash(1_285_925_246)
internal val Res.string.leaderboard_back_to_menu: StringResource by lazy {
      StringResource("string:leaderboard_back_to_menu", "leaderboard_back_to_menu", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1806, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1806, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1894, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1898, 52),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2150, 60),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2014, 64),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1806, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2533, 48),
      ))
    }

@delegate:ResourceContentHash(1_959_523_597)
internal val Res.string.leaderboard_champions_podium: StringResource by lazy {
      StringResource("string:leaderboard_champions_podium", "leaderboard_champions_podium", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1855, 64),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1855, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1947, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1951, 72),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2211, 80),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2079, 68),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1855, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2582, 64),
      ))
    }

@delegate:ResourceContentHash(-1_182_930_454)
internal val Res.string.leaderboard_global_standings: StringResource by lazy {
      StringResource("string:leaderboard_global_standings", "leaderboard_global_standings", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1920, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1920, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2016, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2024, 64),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2292, 52),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2148, 56),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1920, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2647, 60),
      ))
    }

@delegate:ResourceContentHash(-998_980_934)
internal val Res.string.leaderboard_loading: StringResource by lazy {
      StringResource("string:leaderboard_loading", "leaderboard_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 1973, 55),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 1973, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2081, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2089, 63),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2345, 79),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2205, 67),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 1973, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2708, 55),
      ))
    }

@delegate:ResourceContentHash(-1_967_169_512)
internal val Res.string.leaderboard_no_entries: StringResource by lazy {
      StringResource("string:leaderboard_no_entries", "leaderboard_no_entries", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2029, 54),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2033, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2137, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2153, 62),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2425, 74),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2273, 78),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2029, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2764, 54),
      ))
    }

@delegate:ResourceContentHash(1_289_004_626)
internal val Res.string.leaderboard_no_scores: StringResource by lazy {
      StringResource("string:leaderboard_no_scores", "leaderboard_no_scores", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2180, 57),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2184, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2304, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2308, 61),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2624, 77),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2484, 69),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2180, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2899, 57),
      ))
    }

@delegate:ResourceContentHash(47_172_870)
internal val Res.string.leaderboard_no_scores_first: StringResource by lazy {
      StringResource("string:leaderboard_no_scores_first", "leaderboard_no_scores_first", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2084, 95),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2088, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2208, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2216, 91),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2500, 123),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2352, 131),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2084, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2819, 79),
      ))
    }

@delegate:ResourceContentHash(-349_950_399)
internal val Res.string.leaderboard_player_count: StringResource by lazy {
      StringResource("string:leaderboard_player_count", "leaderboard_player_count", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2238, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2242, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2370, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2370, 48),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2702, 68),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2554, 64),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2238, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2957, 48),
      ))
    }

@delegate:ResourceContentHash(1_757_967_884)
internal val Res.string.leaderboard_subtitle: StringResource by lazy {
      StringResource("string:leaderboard_subtitle", "leaderboard_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2356, 72),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2360, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2500, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2496, 108),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2844, 104),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2680, 76),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2356, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3071, 84),
      ))
    }

@delegate:ResourceContentHash(143_270_482)
internal val Res.string.leaderboard_subtitle_compact: StringResource by lazy {
      StringResource("string:leaderboard_subtitle_compact", "leaderboard_subtitle_compact", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2291, 64),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2295, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2423, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2419, 76),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2771, 72),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2619, 60),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2291, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3006, 64),
      ))
    }

@delegate:ResourceContentHash(-687_818_807)
internal val Res.string.leaderboard_title: StringResource by lazy {
      StringResource("string:leaderboard_title", "leaderboard_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2429, 45),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2433, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2609, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2605, 65),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 2949, 53),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2757, 53),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2429, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3156, 53),
      ))
    }

@delegate:ResourceContentHash(103_572_578)
internal val Res.string.menu_default_challenger: StringResource by lazy {
      StringResource("string:menu_default_challenger", "menu_default_challenger", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2475, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2479, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2671, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2671, 55),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3003, 67),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2811, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2475, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3210, 55),
      ))
    }

@delegate:ResourceContentHash(1_499_445_364)
internal val Res.string.menu_default_player_name: StringResource by lazy {
      StringResource("string:menu_default_player_name", "menu_default_player_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2527, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2531, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2727, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2727, 40),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3071, 52),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2863, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2527, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3266, 40),
      ))
    }

@delegate:ResourceContentHash(-900_165_296)
internal val Res.string.menu_edit: StringResource by lazy {
      StringResource("string:menu_edit", "menu_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2568, 33),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2572, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2772, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2768, 37),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3124, 33),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2912, 33),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2568, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3307, 29),
      ))
    }

@delegate:ResourceContentHash(-258_003_885)
internal val Res.string.menu_leaderboard: StringResource by lazy {
      StringResource("string:menu_leaderboard", "menu_leaderboard", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2602, 44),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2606, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2806, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2806, 44),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3158, 60),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2946, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2602, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3337, 48),
      ))
    }

@delegate:ResourceContentHash(1_814_539_032)
internal val Res.string.menu_onboarding_hint: StringResource by lazy {
      StringResource("string:menu_onboarding_hint", "menu_onboarding_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2647, 112),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2651, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2859, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2851, 100),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3219, 144),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 2995, 108),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2647, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3386, 96),
      ))
    }

@delegate:ResourceContentHash(-829_370_945)
internal val Res.string.menu_player_blob: StringResource by lazy {
      StringResource("string:menu_player_blob", "menu_player_blob", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2760, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2764, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2952, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2952, 44),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3364, 56),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3104, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2760, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3483, 40),
      ))
    }

@delegate:ResourceContentHash(-1_936_581_293)
internal val Res.string.menu_settings: StringResource by lazy {
      StringResource("string:menu_settings", "menu_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2801, 41),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2805, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3001, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2997, 45),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3421, 41),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3157, 41),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2801, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3524, 41),
      ))
    }

@delegate:ResourceContentHash(-635_169_620)
internal val Res.string.menu_sp_onboarding_hint: StringResource by lazy {
      StringResource("string:menu_sp_onboarding_hint", "menu_sp_onboarding_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3566, 107),
      ))
    }

@delegate:ResourceContentHash(-1_496_321_093)
internal val Res.string.menu_sp_tagline: StringResource by lazy {
      StringResource("string:menu_sp_tagline", "menu_sp_tagline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3674, 103),
      ))
    }

@delegate:ResourceContentHash(2_113_914_106)
internal val Res.string.menu_start_game: StringResource by lazy {
      StringResource("string:menu_start_game", "menu_start_game", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2843, 39),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2847, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3043, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3043, 31),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3463, 43),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3199, 43),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2843, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3778, 39),
      ))
    }

@delegate:ResourceContentHash(1_002_308_250)
internal val Res.string.menu_start_single_player: StringResource by lazy {
      StringResource("string:menu_start_single_player", "menu_start_single_player", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3818, 44),
      ))
    }

@delegate:ResourceContentHash(1_249_870_948)
internal val Res.string.menu_tagline: StringResource by lazy {
      StringResource("string:menu_tagline", "menu_tagline", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2883, 56),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2887, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3087, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3075, 60),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3507, 72),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3243, 68),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2883, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3863, 48),
      ))
    }

@delegate:ResourceContentHash(1_441_826_410)
internal val Res.string.multiplayer: StringResource by lazy {
      StringResource("string:multiplayer", "multiplayer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3961, 35),
      ))
    }

@delegate:ResourceContentHash(735_876_070)
internal val Res.string.multiplayer_desc: StringResource by lazy {
      StringResource("string:multiplayer_desc", "multiplayer_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3912, 48),
      ))
    }

@delegate:ResourceContentHash(-1_049_396_170)
internal val Res.string.nickname_not_allowed: StringResource by lazy {
      StringResource("string:nickname_not_allowed", "nickname_not_allowed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2940, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2944, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3140, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3136, 56),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3580, 92),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3312, 80),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2940, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3997, 56),
      ))
    }

@delegate:ResourceContentHash(-25_462_792)
internal val Res.string.onboarding_back: StringResource by lazy {
      StringResource("string:onboarding_back", "onboarding_back", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 2989, 31),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 2993, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3193, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3193, 31),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3673, 31),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3393, 31),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 2989, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4054, 31),
      ))
    }

@delegate:ResourceContentHash(1_346_688_808)
internal val Res.string.onboarding_cancel: StringResource by lazy {
      StringResource("string:onboarding_cancel", "onboarding_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3021, 33),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3025, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3225, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3225, 37),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3705, 45),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3425, 33),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3021, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4086, 33),
      ))
    }

@delegate:ResourceContentHash(1_122_516_439)
internal val Res.string.onboarding_char_range_hint: StringResource by lazy {
      StringResource("string:onboarding_char_range_hint", "onboarding_char_range_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3055, 62),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3059, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3263, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3263, 66),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3751, 58),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3459, 50),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3055, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4120, 66),
      ))
    }

@delegate:ResourceContentHash(-1_815_977_720)
internal val Res.string.onboarding_error_max_chars: StringResource by lazy {
      StringResource("string:onboarding_error_max_chars", "onboarding_error_max_chars", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3118, 78),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3122, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3330, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3330, 94),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3810, 94),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3510, 94),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3118, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4187, 78),
      ))
    }

@delegate:ResourceContentHash(-818_670_595)
internal val Res.string.onboarding_error_min_chars: StringResource by lazy {
      StringResource("string:onboarding_error_min_chars", "onboarding_error_min_chars", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3197, 70),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3201, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3425, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3425, 90),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 3905, 94),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3605, 90),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3197, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4266, 78),
      ))
    }

@delegate:ResourceContentHash(1_889_541_931)
internal val Res.string.onboarding_live_preview_hint: StringResource by lazy {
      StringResource("string:onboarding_live_preview_hint", "onboarding_live_preview_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3268, 88),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3272, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3508, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3516, 112),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4000, 104),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3696, 96),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3268, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4345, 92),
      ))
    }

@delegate:ResourceContentHash(-1_833_540_460)
internal val Res.string.onboarding_next: StringResource by lazy {
      StringResource("string:onboarding_next", "onboarding_next", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3357, 35),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3361, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3609, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3629, 35),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4105, 31),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3793, 31),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3357, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4438, 31),
      ))
    }

@delegate:ResourceContentHash(795_343_699)
internal val Res.string.onboarding_nickname_label: StringResource by lazy {
      StringResource("string:onboarding_nickname_label", "onboarding_nickname_label", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3393, 49),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3397, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3645, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3665, 57),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4137, 77),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3825, 65),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3393, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4470, 53),
      ))
    }

@delegate:ResourceContentHash(955_593_006)
internal val Res.string.onboarding_nickname_placeholder: StringResource by lazy {
      StringResource("string:onboarding_nickname_placeholder", "onboarding_nickname_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3443, 59),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3447, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3703, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3723, 67),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4215, 79),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3891, 67),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3443, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4524, 63),
      ))
    }

@delegate:ResourceContentHash(-1_468_959_814)
internal val Res.string.onboarding_playing_as: StringResource by lazy {
      StringResource("string:onboarding_playing_as", "onboarding_playing_as", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3503, 57),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3507, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3767, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3791, 49),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4295, 53),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 3959, 53),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3503, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4588, 53),
      ))
    }

@delegate:ResourceContentHash(1_307_469_344)
internal val Res.string.onboarding_random_button: StringResource by lazy {
      StringResource("string:onboarding_random_button", "onboarding_random_button", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3561, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3565, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3821, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3841, 48),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4349, 48),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4013, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3561, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4642, 40),
      ))
    }

@delegate:ResourceContentHash(515_486_332)
internal val Res.string.onboarding_start_playing: StringResource by lazy {
      StringResource("string:onboarding_start_playing", "onboarding_start_playing", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3602, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3606, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3866, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3890, 56),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4398, 52),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4054, 56),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3602, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4683, 52),
      ))
    }

@delegate:ResourceContentHash(1_784_244_335)
internal val Res.string.onboarding_step_1_heading: StringResource by lazy {
      StringResource("string:onboarding_step_1_heading", "onboarding_step_1_heading", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3655, 57),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3659, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3923, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3947, 61),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4451, 69),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4111, 73),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3655, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4736, 61),
      ))
    }

@delegate:ResourceContentHash(-847_044_554)
internal val Res.string.onboarding_step_1_pill: StringResource by lazy {
      StringResource("string:onboarding_step_1_pill", "onboarding_step_1_pill", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3782, 54),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3786, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4046, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4078, 54),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4614, 74),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4258, 54),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3782, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4867, 54),
      ))
    }

@delegate:ResourceContentHash(11_480_605)
internal val Res.string.onboarding_step_1_pill_completed: StringResource by lazy {
      StringResource("string:onboarding_step_1_pill_completed", "onboarding_step_1_pill_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3713, 68),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3717, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3981, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4009, 68),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4521, 92),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4185, 72),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3713, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4798, 68),
      ))
    }

@delegate:ResourceContentHash(-782_309_107)
internal val Res.string.onboarding_step_1_subheading: StringResource by lazy {
      StringResource("string:onboarding_step_1_subheading", "onboarding_step_1_subheading", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3837, 108),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3841, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4097, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4133, 116),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4689, 132),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4313, 120),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3837, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4922, 104),
      ))
    }

@delegate:ResourceContentHash(1_924_626_818)
internal val Res.string.onboarding_step_1_title: StringResource by lazy {
      StringResource("string:onboarding_step_1_title", "onboarding_step_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 3946, 63),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 3950, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4210, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4250, 51),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4822, 55),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4434, 47),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 3946, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5027, 47),
      ))
    }

@delegate:ResourceContentHash(-1_154_266_290)
internal val Res.string.onboarding_step_2_heading: StringResource by lazy {
      StringResource("string:onboarding_step_2_heading", "onboarding_step_2_heading", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4010, 57),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4014, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4258, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4302, 65),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4878, 61),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4482, 73),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4010, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5075, 57),
      ))
    }

@delegate:ResourceContentHash(760_054_323)
internal val Res.string.onboarding_step_2_pill: StringResource by lazy {
      StringResource("string:onboarding_step_2_pill", "onboarding_step_2_pill", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4068, 54),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4072, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4312, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4368, 54),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 4940, 66),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4556, 54),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4068, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5133, 50),
      ))
    }

@delegate:ResourceContentHash(-1_070_143_065)
internal val Res.string.onboarding_step_2_subheading: StringResource by lazy {
      StringResource("string:onboarding_step_2_subheading", "onboarding_step_2_subheading", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4123, 108),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4127, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4363, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4423, 124),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5007, 124),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4611, 132),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4123, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5184, 108),
      ))
    }

@delegate:ResourceContentHash(-1_386_226_884)
internal val Res.string.onboarding_step_2_title: StringResource by lazy {
      StringResource("string:onboarding_step_2_title", "onboarding_step_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4232, 63),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4236, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4480, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4548, 51),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5132, 55),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4744, 47),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4232, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5293, 47),
      ))
    }

@delegate:ResourceContentHash(472_506_082)
internal val Res.string.onboarding_tab_color: StringResource by lazy {
      StringResource("string:onboarding_tab_color", "onboarding_tab_color", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4296, 44),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4300, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4528, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4600, 48),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5188, 48),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4792, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4296, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5341, 52),
      ))
    }

@delegate:ResourceContentHash(-17_331_855)
internal val Res.string.onboarding_tab_emoji: StringResource by lazy {
      StringResource("string:onboarding_tab_emoji", "onboarding_tab_emoji", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hans"), ), "${MD}values-b+zh+Hans/strings.commonMain.cvr", 4341, 44),
        ResourceItem(setOf(LanguageQualifier("zh"), ScriptQualifier("Hant"), ), "${MD}values-b+zh+Hant/strings.commonMain.cvr", 4345, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4577, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4649, 52),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 5237, 56),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 4841, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 4341, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5394, 48),
      ))
    }

@delegate:ResourceContentHash(1_976_758_684)
internal val Res.string.privacy_back: StringResource by lazy {
      StringResource("string:privacy_back", "privacy_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5443, 28),
      ))
    }

@delegate:ResourceContentHash(-1_916_210_132)
internal val Res.string.privacy_body_contact: StringResource by lazy {
      StringResource("string:privacy_body_contact", "privacy_body_contact", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5472, 168),
      ))
    }

@delegate:ResourceContentHash(-345_857_218)
internal val Res.string.privacy_body_operator: StringResource by lazy {
      StringResource("string:privacy_body_operator", "privacy_body_operator", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5641, 265),
      ))
    }

@delegate:ResourceContentHash(-1_332_822_542)
internal val Res.string.privacy_body_retention: StringResource by lazy {
      StringResource("string:privacy_body_retention", "privacy_body_retention", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5907, 238),
      ))
    }

@delegate:ResourceContentHash(-1_070_480_398)
internal val Res.string.privacy_body_summary: StringResource by lazy {
      StringResource("string:privacy_body_summary", "privacy_body_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6146, 400),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("ai_player_body", Res.string.ai_player_body)
  map.put("ai_player_ok", Res.string.ai_player_ok)
  map.put("app_name", Res.string.app_name)
  map.put("back", Res.string.back)
  map.put("back_to_hub", Res.string.back_to_hub)
  map.put("blocked_player_name", Res.string.blocked_player_name)
  map.put("blocked_players_empty", Res.string.blocked_players_empty)
  map.put("blocked_players_title", Res.string.blocked_players_title)
  map.put("blocked_players_unblock", Res.string.blocked_players_unblock)
  map.put("cancel", Res.string.cancel)
  map.put("clear_data_button", Res.string.clear_data_button)
  map.put("clear_data_card_title", Res.string.clear_data_card_title)
  map.put("clear_data_confirm", Res.string.clear_data_confirm)
  map.put("clear_data_desc", Res.string.clear_data_desc)
  map.put("clear_data_dialog_desc", Res.string.clear_data_dialog_desc)
  map.put("clear_data_dialog_title", Res.string.clear_data_dialog_title)
  map.put("clear_data_success", Res.string.clear_data_success)
  map.put("connecting_back_to_menu", Res.string.connecting_back_to_menu)
  map.put("connecting_error_default", Res.string.connecting_error_default)
  map.put("connecting_error_title", Res.string.connecting_error_title)
  map.put("connecting_retry", Res.string.connecting_retry)
  map.put("connecting_status_default", Res.string.connecting_status_default)
  map.put("connecting_status_joined", Res.string.connecting_status_joined)
  map.put("connecting_status_joining", Res.string.connecting_status_joining)
  map.put("connecting_title", Res.string.connecting_title)
  map.put("game_btn_eject", Res.string.game_btn_eject)
  map.put("game_btn_split", Res.string.game_btn_split)
  map.put("game_exit_confirm_leave", Res.string.game_exit_confirm_leave)
  map.put("game_exit_confirm_message", Res.string.game_exit_confirm_message)
  map.put("game_exit_confirm_stay", Res.string.game_exit_confirm_stay)
  map.put("game_exit_confirm_title", Res.string.game_exit_confirm_title)
  map.put("game_hud_joystick", Res.string.game_hud_joystick)
  map.put("game_hud_leaderboard", Res.string.game_hud_leaderboard)
  map.put("game_hud_mass", Res.string.game_hud_mass)
  map.put("game_hud_pause", Res.string.game_hud_pause)
  map.put("game_over_main_menu", Res.string.game_over_main_menu)
  map.put("game_over_play_again", Res.string.game_over_play_again)
  map.put("game_over_stats", Res.string.game_over_stats)
  map.put("game_over_title", Res.string.game_over_title)
  map.put("game_paused_exit", Res.string.game_paused_exit)
  map.put("game_paused_hint", Res.string.game_paused_hint)
  map.put("game_paused_restart", Res.string.game_paused_restart)
  map.put("game_paused_resume", Res.string.game_paused_resume)
  map.put("game_paused_title", Res.string.game_paused_title)
  map.put("hub_subtitle", Res.string.hub_subtitle)
  map.put("hub_version_label", Res.string.hub_version_label)
  map.put("leaderboard_back_to_menu", Res.string.leaderboard_back_to_menu)
  map.put("leaderboard_champions_podium", Res.string.leaderboard_champions_podium)
  map.put("leaderboard_global_standings", Res.string.leaderboard_global_standings)
  map.put("leaderboard_loading", Res.string.leaderboard_loading)
  map.put("leaderboard_no_entries", Res.string.leaderboard_no_entries)
  map.put("leaderboard_no_scores", Res.string.leaderboard_no_scores)
  map.put("leaderboard_no_scores_first", Res.string.leaderboard_no_scores_first)
  map.put("leaderboard_player_count", Res.string.leaderboard_player_count)
  map.put("leaderboard_subtitle", Res.string.leaderboard_subtitle)
  map.put("leaderboard_subtitle_compact", Res.string.leaderboard_subtitle_compact)
  map.put("leaderboard_title", Res.string.leaderboard_title)
  map.put("menu_default_challenger", Res.string.menu_default_challenger)
  map.put("menu_default_player_name", Res.string.menu_default_player_name)
  map.put("menu_edit", Res.string.menu_edit)
  map.put("menu_leaderboard", Res.string.menu_leaderboard)
  map.put("menu_onboarding_hint", Res.string.menu_onboarding_hint)
  map.put("menu_player_blob", Res.string.menu_player_blob)
  map.put("menu_settings", Res.string.menu_settings)
  map.put("menu_sp_onboarding_hint", Res.string.menu_sp_onboarding_hint)
  map.put("menu_sp_tagline", Res.string.menu_sp_tagline)
  map.put("menu_start_game", Res.string.menu_start_game)
  map.put("menu_start_single_player", Res.string.menu_start_single_player)
  map.put("menu_tagline", Res.string.menu_tagline)
  map.put("multiplayer", Res.string.multiplayer)
  map.put("multiplayer_desc", Res.string.multiplayer_desc)
  map.put("nickname_not_allowed", Res.string.nickname_not_allowed)
  map.put("onboarding_back", Res.string.onboarding_back)
  map.put("onboarding_cancel", Res.string.onboarding_cancel)
  map.put("onboarding_char_range_hint", Res.string.onboarding_char_range_hint)
  map.put("onboarding_error_max_chars", Res.string.onboarding_error_max_chars)
  map.put("onboarding_error_min_chars", Res.string.onboarding_error_min_chars)
  map.put("onboarding_live_preview_hint", Res.string.onboarding_live_preview_hint)
  map.put("onboarding_next", Res.string.onboarding_next)
  map.put("onboarding_nickname_label", Res.string.onboarding_nickname_label)
  map.put("onboarding_nickname_placeholder", Res.string.onboarding_nickname_placeholder)
  map.put("onboarding_playing_as", Res.string.onboarding_playing_as)
  map.put("onboarding_random_button", Res.string.onboarding_random_button)
  map.put("onboarding_start_playing", Res.string.onboarding_start_playing)
  map.put("onboarding_step_1_heading", Res.string.onboarding_step_1_heading)
  map.put("onboarding_step_1_pill", Res.string.onboarding_step_1_pill)
  map.put("onboarding_step_1_pill_completed", Res.string.onboarding_step_1_pill_completed)
  map.put("onboarding_step_1_subheading", Res.string.onboarding_step_1_subheading)
  map.put("onboarding_step_1_title", Res.string.onboarding_step_1_title)
  map.put("onboarding_step_2_heading", Res.string.onboarding_step_2_heading)
  map.put("onboarding_step_2_pill", Res.string.onboarding_step_2_pill)
  map.put("onboarding_step_2_subheading", Res.string.onboarding_step_2_subheading)
  map.put("onboarding_step_2_title", Res.string.onboarding_step_2_title)
  map.put("onboarding_tab_color", Res.string.onboarding_tab_color)
  map.put("onboarding_tab_emoji", Res.string.onboarding_tab_emoji)
  map.put("privacy_back", Res.string.privacy_back)
  map.put("privacy_body_contact", Res.string.privacy_body_contact)
  map.put("privacy_body_operator", Res.string.privacy_body_operator)
  map.put("privacy_body_retention", Res.string.privacy_body_retention)
  map.put("privacy_body_summary", Res.string.privacy_body_summary)
}
